import { supabase } from '@/integrations/supabase/client';
import type { CardOutcome } from '@/components/ask-cannafax/streamChat';

/** Saves what happened to a chat action card so reopening the conversation shows it in place. Best-effort. */
export async function saveCardOutcome(threadId: string | null | undefined, cardId: string | undefined, outcome: CardOutcome) {
  if (!threadId || !cardId) return;
  const { error } = await supabase.rpc('record_help_card_outcome' as never, {
    _thread_id: threadId,
    _card_id: cardId,
    _outcome: outcome,
  } as never);
  if (error) console.warn('[chat-card] outcome not saved', error.message);
}

/** Backend COA job statuses that mean the work has really finished. */
export const COA_TERMINAL = ['completed', 'failed', 'not_a_coa'] as const;
export function isCoaTerminal(status: string | null | undefined): boolean {
  return !!status && (COA_TERMINAL as readonly string[]).includes(status);
}

